"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const ReleaseDataSection = (props) => {
    const { recordingData } = props;
    const { productTitle, productDisplayArtistName, label, icpn, releaseDate, catalogNumber, dspReleaseId } = recordingData;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "section-header" },
            react_1.default.createElement("img", { src: common_1.ICONS.recordingMusic }),
            react_1.default.createElement("h5", null, "Release Data")),
        react_1.default.createElement("div", { className: 'details release-details' },
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Release Title:"),
                react_1.default.createElement("p", { className: "semi-bold" }, productTitle || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Release Artist:"),
                react_1.default.createElement("p", { className: "semi-bold" }, productDisplayArtistName.join(', ') || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Release Label:"),
                react_1.default.createElement("p", { className: "semi-bold" }, label || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "UPC/EAN:"),
                react_1.default.createElement("p", { className: "semi-bold" }, icpn || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Release Date(s):"),
                react_1.default.createElement("p", { className: "semi-bold" }, releaseDate || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "Catalog Number:"),
                react_1.default.createElement("p", { className: "semi-bold" }, catalogNumber || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "DSP Release ID:"),
                react_1.default.createElement("p", { className: "semi-bold" }, dspReleaseId || 'N/A')),
            react_1.default.createElement("div", { className: 'horizontal-detail-pair' },
                react_1.default.createElement("p", { className: "label" }, "P Line:"),
                react_1.default.createElement("p", { className: "semi-bold" }, "N/A")))));
};
exports.default = ReleaseDataSection;
